export const LOGIN_SUCCESS = 'login:SUCCESS'
export const LOGIN_ERROR = 'login:ERROR'
export const SUBMIT_LOGIN = 'login:SUBMIT'
export const LOGOUT = 'login:LOGOUT'

export const SIGNUP_SUCCESS = 'signup:SUCCESS'
export const SIGNUP_ERROR = 'signup:ERROR'
export const SUBMIT_SIGNUP = 'signup:SUBMIT'
export const FINISH_SIGNUP = 'signup:FINISH'

export const FINISH_SIGNUP_SUCCESS = 'finish_signup:SUCCESS'
export const FINISH_SIGNUP_ERROR = 'finish_signup:ERROR'
export const FINISH_SIGNUP_SUBMIT = 'finish_signup:SUBMIT'
export const FINISH_SIGNUP_STEP_SUCCESS = 'finish_signup_step:SUCCESS'

export const USER_INFO = 'user:INFO'
export const USER_INFO_LOAD = 'user:INFO_LOAD'
export const USER_INFO_ERROR = 'user:INFO_ERROR'
export const USERS_LOAD = 'users:LOAD'
export const USERS_SUCCESS = 'users:SUCCESS'
export const USERS_ERROR = 'users:ERROR'

export const USER_COMPLETE_LOAD = 'user_complete:LOAD'
export const USER_COMPLETE_ERROR = 'user_complete:ERROR'
export const USER_COMPLETE_SUCCESS = 'user_complete:SUCCESS'

export const USER_ACCESS_LOAD = 'user_access:LOAD'
export const USER_ACCESS_ERROR = 'user_access:ERROR'
export const USER_ACCESS_SUCCESS = 'user_access:SUCCESS'

export const CONTRATOS_CREATE_SUCCESS = 'contratos:CREATE_SUCCESS'
export const CONTRATOS_CREATE_ERROR = 'contratos:CREATE_ERROR'
export const CONTRATOS_CREATE_LOAD = 'contratos:CREATE_LOAD'
export const CONTRATOS_LOAD = 'contratos:LOAD'
export const CONTRATOS_SUCCESS = 'contratos:SUCCESS'
export const CONTRATOS_ERROR = 'contratos:ERROR'
export const CONTRATOS_PENDENTES_LOAD = 'contratos:PENDENTES_LOAD'
export const CONTRATOS_PENDENTES_SUCCESS = 'contratos:PENDENTES_SUCCESS'
export const CONTRATOS_PENDENTES_ERROR = 'contratos:PENDENTES_ERROR'

export const CLEAR_MESSAGE = 'contratos:CLEAR_MESSAGE'

export const CONTRATOS_RENEWAL_SUCCESS = 'contratos:RENEWAL_SUCCESS'
export const CONTRATOS_RENEWAL_ERROR = 'contratos:RENEWAL_ERROR'
export const CONTRATOS_RENEWAL_LOAD = 'contratos:RENEWAL_LOAD'

export const APORTES_PENDENTES_LOAD = 'aportes:PENDENTES_LOAD'
export const APORTES_PENDENTES_SUCCESS = 'aportes:PENDENTES_SUCCESS'
export const APORTES_PENDENTES_ERROR = 'aportes:PENDENTES_ERROR'

export const RESGATES_PENDENTES_LOAD = 'resgates:PENDENTES_LOAD'
export const RESGATES_PENDENTES_SUCCESS = 'resgates:PENDENTES_SUCCESS'
export const RESGATES_PENDENTES_ERROR = 'resgates:PENDENTES_ERROR'

export const CONTRATO_LOAD = 'contrato:LOAD'
export const CONTRATO_SUCCESS = 'contrato:SUCCESS'
export const CONTRATO_ERROR = 'contrato:ERROR'
export const CONTRATOS_RESET = 'contratos:RESET'

export const SALDO_SUCCESS = 'saldo:SUCCESS'
export const SALDO_ERROR = 'saldo:ERROR'
export const SALDO_LOAD = 'saldo:SALDO_LOAD'

export const LOG_SUCCESS = 'log:SUCCESS'
export const LOG_ERROR = 'log:ERROR'
export const LOG_LOAD = 'log:LOG_LOAD'

export const OPERACOES_SUCCESS = 'operacoes:SUCCESS'
export const OPERACOES_ERROR = 'operacoes:ERROR'
export const OPERACOES_LOAD = 'operacoes:OPERACOES_LOAD'

export const NOTIFICATIONS_SUCCESS = 'notifications:SUCCESS'
export const NOTIFICATIONS_ERROR = 'notifications:ERROR'
export const NOTIFICATIONS_LOAD = 'notifications:NOTIFICATIONS_LOAD'

export const SPIRIT_APROVACAO_SUCCESS = 'spirit_aprovacao:SUCCESS'
export const SPIRIT_APROVACAO_ERROR = 'spirit_aprovacao:ERROR'
export const SPIRIT_APROVACAO_LOAD = 'spirit_aprovacao:SPIRIT_APROVACAO_LOAD'

export const CONVERSOES_SUCCESS = 'conversoes:SUCCESS'
export const CONVERSOES_ERROR = 'conversoes:ERROR'
export const CONVERSOES_LOAD = 'conversoes:CONVERSOES_LOAD'

export const ADMIN_BALANCE_SUCCESS = 'admin_balance:SUCCESS'
export const ADMIN_BALANCE_ERROR = 'admin_balance:ERROR'
export const ADMIN_BALANCE_LOAD = 'admin_balance:LOAD'

export const RECIPTS_SUCCESS = 'recipts:SUCCESS'
export const RECIPTS_ERROR = 'recipts:ERROR'
export const RECIPTS_LOAD = 'recipts:LOAD'

export const WALLET_BTC_ADDRESS_LOAD = 'wallet_btc_address:LOAD'
export const WALLET_BTC_ADDRESS_ERROR = 'wallet_btc_address:ERROR'
export const WALLET_BTC_ADDRESS_SUCCESS = 'wallet_btc_address:SUCCESS'

export const WALLET_BTC_FEE_LOAD = 'wallet_btc_fee:LOAD'
export const WALLET_BTC_FEE_ERROR = 'wallet_btc_fee:ERROR'
export const WALLET_BTC_FEE_SUCCESS = 'wallet_btc_fee:SUCCESS'

export const WALLET_BTC_BALANCE_LOAD = 'wallet_btc_balance:LOAD'
export const WALLET_BTC_BALANCE_ERROR = 'wallet_btc_balance:ERROR'
export const WALLET_BTC_BALANCE_SUCCESS = 'wallet_btc_balance:SUCCESS'

export const WALLET_BTC_BTCOUT_SUBMIT = 'wallet_btc_btcout:SUBMIT'
export const WALLET_BTC_BTCOUT_ERROR = 'wallet_btc_btcout:ERROR'
export const WALLET_BTC_BTCOUT_SUCCESS = 'wallet_btc_btcout:SUCCESS'

export const WALLET_TRANSACTIONS_STATEMENT_LOAD = 'wallet_transactions_statement:LOAD'
export const WALLET_TRANSACTIONS_STATEMENT_ERROR = 'wallet_transactions_statement:ERROR'
export const WALLET_TRANSACTIONS_STATEMENT_SUCCESS = 'wallet_transactions_statement:SUCCESS'

export const WALLET_TRANSACTIONS_DETAIL_LOAD = 'wallet_transactions_detail:LOAD'
export const WALLET_TRANSACTIONS_DETAIL_ERROR = 'wallet_transactions_detail:ERROR'
export const WALLET_TRANSACTIONS_DETAIL_SUCCESS = 'wallet_transactions_detail:SUCCESS'

export const WALLET_TRANSACTIONS_CONVERSION_SUBMIT = 'wallet_transactions_conversion:SUBMIT'
export const WALLET_TRANSACTIONS_CONVERSION_ERROR = 'wallet_transactions_conversion:ERROR'
export const WALLET_TRANSACTIONS_CONVERSION_SUCCESS = 'wallet_transactions_conversion:SUCCESS'

export const WALLET_TRANSACTIONS_FAVORITES_LOAD = 'wallet_transactions_favorites:LOAD'
export const WALLET_TRANSACTIONS_FAVORITES_ERROR = 'wallet_transactions_favorites:ERROR'
export const WALLET_TRANSACTIONS_FAVORITES_SUCCESS = 'wallet_transactions_favorites:SUCCESS'

export const WALLET_BRL_CASHOUT_SUBMIT = 'wallet_brl_cashout:SUBMIT'
export const WALLET_BRL_CASHOUT_ERROR = 'wallet_brl_cashout:ERROR'
export const WALLET_BRL_CASHOUT_SUCCESS = 'wallet_brl_cashout:SUCCESS'

export const WALLET_BRL_CASHIN_SUBMIT = 'wallet_brl_cashin:SUBMIT'
export const WALLET_BRL_CASHIN_ERROR = 'wallet_brl_cashin:ERROR'
export const WALLET_BRL_CASHIN_SUCCESS = 'wallet_brl_cashin:SUCCESS'
export const WALLET_BRL_CASHIN_FILE = 'wallet_brl_cashin:FILE'

export const WALLET_BRL_BALANCE_LOAD = 'wallet_brl_balance:LOAD'
export const WALLET_BRL_BALANCE_ERROR = 'wallet_brl_balance:ERROR'
export const WALLET_BRL_BALANCE_SUCCESS = 'wallet_brl_balance:SUCCESS'

export const WALLET_LOGIN_SUCCESS = 'wallet:LOGIN_SUCCESS'
export const WALLET_LOGIN_ERROR = 'wallet:LOGIN_ERROR'
export const WALLET_LOGIN_SUBMIT = 'wallet:LOGIN_SUBMIT'
export const WALLET_LOGIN_EXPIRED = 'wallet:LOGIN_EXPIRED'

export const WALLET_CREATION_SUCCESS = 'wallet:CREATION_SUCCESS'
export const WALLET_CREATION_ERROR = 'wallet:CREATION_ERROR'
export const WALLET_CREATION_SUBMIT = 'wallet:CREATION_SUBMIT'

export const WALLET_FINISH_SUCCESS = 'wallet:FINISH_SUCCESS'
export const WALLET_FINISH_ERROR = 'wallet:FINISH_ERROR'
export const WALLET_FINISH_LOAD = 'wallet:FINISH_LOAD'

export const WALLET_SMS_SUCCESS = 'wallet:SMS_SUCCESS'
export const WALLET_SMS_ERROR = 'wallet:SMS_ERROR'
export const WALLET_SMS_SUBMIT = 'wallet:SMS_SUBMIT'

export const WALLET_LISTA_SUCCESS = 'wallet:LISTA_SUCCESS'
export const WALLET_LISTA_ERROR = 'wallet:LISTA_ERROR'
export const WALLET_LISTA_SUBMIT = 'wallet:LISTA_SUBMIT'

export const WALLET_TOKEN_COUNT_SUCCESS = 'wallet:TOKEN_COUNT_SUCCESS'
export const WALLET_TOKEN_COUNT_ERROR = 'wallet:TOKEN_COUNT_ERROR'
export const WALLET_TOKEN_COUNT_LOAD = 'wallet:TOKEN_COUNT_LOAD'

export const WALLET_TOKEN_SUCCESS = 'wallet:TOKEN_SUCCESS'
export const WALLET_TOKEN_ERROR = 'wallet:TOKEN_ERROR'
export const WALLET_TOKEN_SUBMIT = 'wallet:TOKEN_SUBMIT'

export const WALLET_GET_TOKEN_ERROR = 'wallet:GET_TOKEN_ERROR'
export const WALLET_GET_TOKEN_SUCCESS = 'wallet:GET_TOKEN_SUCCESS'
export const WALLET_GET_TOKEN_LOAD = 'wallet:GET_TOKEN_LOAD'

export const WALLET_TOKEN_REQUEST_SUCCESS = 'wallet:TOKEN_REQUEST_SUCCESS'
export const WALLET_TOKEN_REQUEST_ERROR = 'wallet:TOKEN_REQUEST_ERROR'
export const WALLET_TOKEN_REQUEST_LOAD = 'wallet:TOKEN_REQUEST_LOAD'

export const WALLET_TOKEN_YIELDFEE_SUCCESS = 'wallet:TOKEN_YIELDFEE_SUCCESS'
export const WALLET_TOKEN_YIELDFEE_ERROR = 'wallet:TOKEN_YIELDFEE_ERROR'
export const WALLET_TOKEN_YIELDFEE_LOAD = 'wallet:TOKEN_YIELDFEE_LOAD'

export const WALLET_TRANSACTIONS_RESUME_SUCCESS = 'wallet:TRANSACTIONS_RESUME_SUCCESS'
export const WALLET_TRANSACTIONS_RESUME_ERROR = 'wallet:TRANSACTIONS_RESUME_ERROR'
export const WALLET_TRANSACTIONS_RESUME_LOAD = 'wallet:TRANSACTIONS_RESUME_LOAD'

export const INDICACOES_CREATE_SUCCESS = 'indicacoes:CREATE_SUCCESS'
export const INDICACOES_CREATE_ERROR = 'indicacoes:CREATE_ERROR'
export const INDICACOES_CREATE_LOAD = 'indicacoes:CREATE_LOAD'
export const INDICACOES_LOAD = 'indicacoes:LOAD'
export const INDICACOES_SUCCESS = 'indicacoes:SUCCESS'
export const INDICACOES_ERROR = 'indicacoes:ERROR'
export const INDICACAO_LOAD = 'indicacao:LOAD'
export const INDICACAO_SUCCESS = 'indicacao:SUCCESS'
export const INDICACAO_ERROR = 'indicacao:ERROR'
export const INDICACOES_RESET = 'indicacoes:RESET'

export const REFERRALS_LOAD = 'referrals:LOAD'
export const REFERRALS_SUCCESS = 'referrals:SUCCESS'
export const REFERRALS_ERROR = 'referrals:ERROR'
export const REFERRAL_CODE_LOAD = 'referral_code:LOAD'
export const REFERRAL_CODE_SUCCESS = 'referral_code:SUCCESS'
export const REFERRAL_CODE_ERROR = 'referral_code:ERROR'
export const COMMISSIONS_LOAD = 'commissions:LOAD'
export const COMMISSIONS_SUCCESS = 'commissions:SUCCESS'
export const COMMISSIONS_ERROR = 'commissions:ERROR'

// Withdrawal action types
export const WITHDRAWALS_LOAD = 'WITHDRAWALS_LOAD'
export const WITHDRAWALS_SUCCESS = 'WITHDRAWALS_SUCCESS'
export const WITHDRAWALS_ERROR = 'WITHDRAWALS_ERROR'